import * as types from './mutation-types'

export const setOldLogs = ({ commit }, payload) => {
    commit(types.ACTIVITY_OLD_LOGS, payload)
}

export const setNewLogs = ({ commit }, payload) => {
    commit(types.ACTIVITY_NEW_LOGS, payload)
}

export const cacheTime = ({ commit }, payload) => {
    commit(types.ACTIVITY_CACHE_TIME, payload)
}

export default {
    setOldLogs,
    setNewLogs,
    cacheTime
}
